import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const METHOD_COLORS = {
  GET: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  POST: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  PUT: 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  PATCH: 'bg-violet-500/15 text-violet-400 border-violet-500/30',
  DELETE: 'bg-red-500/15 text-red-400 border-red-500/30',
};

const EndpointCard = ({ endpoint }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [copiedParam, setCopiedParam] = useState(null);

  const copyToClipboard = (text, id) => {
    navigator.clipboard?.writeText(text);
    setCopiedParam(id);
    setTimeout(() => setCopiedParam(null), 1500);
  };

  return (
    <div className="border border-border rounded-lg overflow-hidden bg-card transition-smooth hover:border-primary/30">
      {/* Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center gap-3 px-5 py-4 text-left hover:bg-muted/40 transition-smooth"
      >
        <span className={`inline-flex items-center px-2.5 py-1 rounded text-xs font-mono font-bold border ${METHOD_COLORS?.[endpoint?.method] || 'bg-muted text-foreground border-border'}`}>
          {endpoint?.method}
        </span>
        <span className="font-mono text-sm text-foreground flex-1">{endpoint?.path}</span>
        <span className="text-sm text-muted-foreground hidden md:block flex-1">{endpoint?.summary}</span>
        <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} color="var(--color-muted-foreground)" />
      </button>
      {/* Expanded Content */}
      {isExpanded && (
        <div className="border-t border-border px-5 py-5 space-y-5">
          <p className="text-sm text-muted-foreground">{endpoint?.description}</p>

          {/* Parameters */}
          {endpoint?.params?.length > 0 && (
            <div>
              <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">Parameters</h4>
              <div className="rounded-lg border border-border overflow-hidden">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-muted/50 border-b border-border">
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-muted-foreground">Name</th>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-muted-foreground">Type</th>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-muted-foreground">Required</th>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-muted-foreground">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {endpoint?.params?.map((param, i) => (
                      <tr key={i} className="border-b border-border last:border-0">
                        <td className="px-4 py-2.5 font-mono text-xs text-primary">{param?.name}</td>
                        <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{param?.type}</td>
                        <td className="px-4 py-2.5">
                          {param?.required
                            ? <span className="text-xs text-red-400 font-medium">required</span>
                            : <span className="text-xs text-muted-foreground">optional</span>}
                        </td>
                        <td className="px-4 py-2.5 text-xs text-muted-foreground">{param?.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Request Body */}
          {endpoint?.requestBody && (
            <div>
              <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">Request Body</h4>
              <div className="relative group">
                <pre className="bg-[#0d1117] text-[#e6edf3] rounded-lg p-4 text-xs font-mono overflow-x-auto leading-relaxed">
                  {endpoint?.requestBody}
                </pre>
                <button
                  onClick={() => copyToClipboard(endpoint?.requestBody, 'body')}
                  className="absolute top-3 right-3 p-1.5 rounded bg-white/10 hover:bg-white/20 transition-smooth opacity-0 group-hover:opacity-100"
                >
                  <Icon name={copiedParam === 'body' ? 'Check' : 'Copy'} size={13} color="#e6edf3" />
                </button>
              </div>
            </div>
          )}

          {/* Response */}
          {endpoint?.response && (
            <div>
              <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">Response</h4>
              <div className="relative group">
                <pre className="bg-[#0d1117] text-[#e6edf3] rounded-lg p-4 text-xs font-mono overflow-x-auto leading-relaxed">
                  {endpoint?.response}
                </pre>
                <button
                  onClick={() => copyToClipboard(endpoint?.response, 'response')}
                  className="absolute top-3 right-3 p-1.5 rounded bg-white/10 hover:bg-white/20 transition-smooth opacity-0 group-hover:opacity-100"
                >
                  <Icon name={copiedParam === 'response' ? 'Check' : 'Copy'} size={13} color="#e6edf3" />
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EndpointCard;
